import BaseFilter from './BaseFilter';
import { requestGetItemCategories as request } from '../../../state/ducks/filters/api';

const ItemNameFilter = ({ value, requestQueryParams, onChange }) =>  BaseFilter({ value, onChange, request, requestQueryParams });

ItemNameFilter.defaultProps = BaseFilter.defaultProps;

export default ItemNameFilter;
